/* External dependencies */
import { Text, Button } from 'atomize';
import React, { ReactNode } from 'react';

/* Local dependencies */
import formatMessage from '../../../intl/formatMessage';
import Popup from '../../popup/Popup';
import PopupContent from '../../popup/PopupContent';
import { CustomButton } from '../custom-button/custom-button';
import { PopupActions } from './popup-actions';

interface CustomPopupProps {
  children: ReactNode;
  submitText: string;
  title: string;
  textColor?: string;
  btnDataTestId?: string;
  submitButtonProps: Button;
  dataTestId?: string;
  onSubmit: () => void;
}

export function CustomPopup(props: CustomPopupProps) {
  const {
    title,
    children,
    textColor,
    submitText,
    dataTestId,
    submitButtonProps,
    btnDataTestId,
    onSubmit,
  } = props;

  return (
    <Popup title={title} dataTestId={dataTestId} onClose={onSubmit}>
      <PopupContent>{children}</PopupContent>
      <PopupActions>
        <CustomButton
          {...defaultSubmitButtonProps}
          {...submitButtonProps}
          onClick={onSubmit}
          dataTestId={btnDataTestId}
        >
          <Text textColor={textColor}>{formatMessage(submitText)}</Text>
        </CustomButton>
      </PopupActions>
    </Popup>
  );
}

const defaultSubmitButtonProps = {
  p: { x: '30px' },
};
